const useSubdomain = () => {
  const simulatedHost =
    process.env.NODE_ENV === 'development' ? 'www.wizco.io' : window.location.hostname
  const host = simulatedHost.split('.')
  const isAdminSubdomain = host.length > 1 && host[0] === 'admin'
  const subdomain = host.length > 1 && host[0] !== 'admin' ? host[0] : undefined

  return { host, isAdminSubdomain, subdomain }
}

export default useSubdomain
